module.exports = __webpack_public_path__ + "static/media/VijayMittal@3x.c720e09d.png";